import { jsx as _jsx } from "react/jsx-runtime";
import { DocumentsPanel } from '../../DocumentsPanel';
import { usePursuitRecord } from '../PursuitRecordContext';
import { PursuitSectionFrame } from '../PursuitSectionFrame';
/** Docs: pursuit-level documents, moved from the Documents tab. */ export function DocumentsSection() {
    const { captureProjectId } = usePursuitRecord();
    // GRW-30: sections always sit in the record shell, so the gate is the header capabilities.
    const { canEdit } = usePursuitRecord().capabilities;
    return /*#__PURE__*/ _jsx(PursuitSectionFrame, {
        title: "Docs",
        children: /*#__PURE__*/ _jsx(DocumentsPanel, {
            readOnly: !canEdit,
            entityId: captureProjectId,
            entityType: "capture_project",
            title: "Pursuit documents"
        })
    });
}
